/**
 * @type {BD_CFG}
 */
const CONFIG = {
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    firebase: window.CFG?.firebase ?? {
        key: "",
        auth_domain: "",
        database_url: "",
        auth_token: "",
        team_code: "",
        environment: "",
    },
    game: window.CFG?.game ?? {
        id: "",
        isFinish: false,
        timeLeft: 0,
        cfgLimit: {
            timeLimit: 0,
            notifications: [],
        },
        rooms: [],
        mainrooms: [],
        is_leader: false,
        is_profile_completed: false,
        teamconnector: {
            categories: [],
            timer: 0,
        },
        debriefing: {
            questions: [],
        },
        game_prop: {
            disableTimer: false,
            singlePlayer: false,
        },
        videos: {},
    },
    isAuth: window.CFG?.isAuth ?? 0,
    mainRoom: window.CFG?.mainRoom ?? "",
    nonce: window.CFG?.nonce ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    user: window.CFG?.user ?? {
        id: 0,
        avatar: "",
        nickname: "",
        email: "",
    },
    avatarOptions: window.CFG?.avatarOptions ?? [],
    default_avatar: window.CFG.default_avatar ?? "",
    strings: {
        allowedFile: window.CFG?.strings.allowedFile ?? "",
        confirmLeave: window.CFG?.strings.confirmLeave ?? "",
        playerLeft: window.CFG?.strings.playerLeft ?? "",
        removedFromTeam: window.CFG?.strings.removedFromTeam ?? ""
    },
    wpml_config: window.CFG?.wpml_config ?? {
        current_language: window.CFG?.wpml_config.current_language ?? "",
    },
};

export default CONFIG;
